import { render, staticRenderFns } from "./TypeSelection.vue?vue&type=template&id=21f01b3c&scoped=true"
import script from "./TypeSelection.vue?vue&type=script&lang=js"
export * from "./TypeSelection.vue?vue&type=script&lang=js"
import style0 from "./TypeSelection.vue?vue&type=style&index=0&id=21f01b3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f01b3c",
  null
  
)

export default component.exports